import { useAnimatedStyle } from 'react-native-reanimated';
const usePriceChangeArrowStyles = (amountSharedValue, forStockSharedValue, originalDataShared, originalXShared) => {
    const upAnimatedStyle = useAnimatedStyle(() => {
        const active = {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            opacity: 1,
        };
        const inactive = { position: 'absolute', opacity: 0 };
        if (forStockSharedValue.value) {
            if (originalDataShared?.value &&
                'closePrices' in originalDataShared.value &&
                originalXShared &&
                originalXShared.value !== '') {
                const value = originalDataShared.value.closePrices[Math.round(originalXShared.value)];
                const openPrice = originalDataShared.value.closePrices[0];
                if (value !== undefined && openPrice !== undefined) {
                    return value > openPrice ? active : inactive;
                }
            }
            if (!amountSharedValue || typeof amountSharedValue.value !== 'number')
                return inactive;
            return amountSharedValue.value > 0 ? active : inactive;
        }
        if (originalDataShared?.value &&
            'profitLoss' in originalDataShared.value &&
            originalXShared &&
            originalXShared.value !== '') {
            const value = originalDataShared.value.profitLoss[Math.round(originalXShared.value)];
            const valueAlt = originalDataShared.value.profitLossPct[Math.round(originalXShared.value)];
            if (value !== undefined && value !== 0) {
                return value > 0 ? active : inactive;
            }
            if (valueAlt !== undefined) {
                return valueAlt > 0 ? active : inactive;
            }
        }
        if (!amountSharedValue || typeof amountSharedValue.value !== 'number')
            return inactive;
        return amountSharedValue.value > 0 ? active : inactive;
    }, [forStockSharedValue, originalDataShared, originalXShared, amountSharedValue]);
    const downAnimatedStyle = useAnimatedStyle(() => {
        const active = {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            opacity: 1,
        };
        const inactive = { position: 'absolute', opacity: 0 };
        if (forStockSharedValue.value) {
            if (originalDataShared?.value &&
                'closePrices' in originalDataShared.value &&
                originalXShared &&
                originalXShared.value !== '') {
                const value = originalDataShared.value.closePrices[Math.round(originalXShared.value)];
                const openPrice = originalDataShared.value.closePrices[0];
                if (value !== undefined && openPrice !== undefined) {
                    return value < openPrice ? active : inactive;
                }
            }
            if (!amountSharedValue || typeof amountSharedValue.value !== 'number')
                return inactive;
            return amountSharedValue.value < 0 ? active : inactive;
        }
        if (originalDataShared?.value &&
            'profitLoss' in originalDataShared.value &&
            originalXShared &&
            originalXShared.value !== '') {
            const value = originalDataShared.value.profitLoss[Math.round(originalXShared.value)];
            const valueAlt = originalDataShared.value.profitLossPct[Math.round(originalXShared.value)];
            if (value !== undefined && value !== 0) {
                return value < 0 ? active : inactive;
            }
            if (valueAlt !== undefined) {
                return valueAlt < 0 ? active : inactive;
            }
        }
        if (!amountSharedValue || typeof amountSharedValue.value !== 'number')
            return inactive;
        return amountSharedValue.value < 0 ? active : inactive;
    }, [forStockSharedValue, originalDataShared, originalXShared, amountSharedValue]);
    const neutralAnimatedStyle = useAnimatedStyle(() => {
        const active = { opacity: 1 };
        const inactive = { opacity: 0 };
        if (forStockSharedValue.value) {
            if (originalDataShared?.value &&
                'closePrices' in originalDataShared.value &&
                originalXShared &&
                originalXShared.value !== '') {
                const value = originalDataShared.value.closePrices[Math.round(originalXShared.value)];
                const openPrice = originalDataShared.value.closePrices[0];
                if (value !== undefined && openPrice !== undefined) {
                    return value === openPrice ? active : inactive;
                }
            }
            if (!amountSharedValue || typeof amountSharedValue.value !== 'number')
                return inactive;
            return amountSharedValue.value === 0 ? active : inactive;
        }
        if (originalDataShared?.value &&
            'profitLoss' in originalDataShared.value &&
            originalXShared &&
            originalXShared.value !== '') {
            const value = originalDataShared.value.profitLoss[Math.round(originalXShared.value)];
            const valueAlt = originalDataShared.value.profitLossPct[Math.round(originalXShared.value)];
            if (value === 0 && valueAlt === 0) {
                return active;
            }
            return inactive;
        }
        if (!amountSharedValue || typeof amountSharedValue.value !== 'number')
            return inactive;
        return amountSharedValue.value === 0 ? active : inactive;
    }, [forStockSharedValue, originalDataShared, originalXShared, amountSharedValue]);
    return [upAnimatedStyle, downAnimatedStyle, neutralAnimatedStyle];
};
export default usePriceChangeArrowStyles;
